import { Box } from "@mui/material";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useMsal } from "@azure/msal-react";
import { OrderBookGrid } from "../../features/orderBook";
import { AlgoFrame } from "./AlgoFrame";
import { ConfigTab } from "../../features/configTab";
import { getUsernameFromMsal } from "../../Services/GraphService";
import "./MainSplit.css";
import { FullDepthOrderbook } from "../../features/fullDepthOrderbook";
import { FC } from "react";

const MainSplit = () => {
  const { accounts, instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  return (
    <PanelGroup
      autoSaveId={`jepx-lazer-desk-main-${getUsernameFromMsal(
        activeAccount ? [activeAccount] : accounts
      )}`}
      direction="vertical"
    >
      <Panel id="orderbook" order={1} defaultSize={40} minSize={15}>
        <Box
          height={"100%"}
          width="100%"
          flexGrow={1}
          minHeight={0}
          paddingTop={1}
          sx={{ display: "flex", gap: 1, overflow: "hidden" }}
        >
          <PanelGroup
            autoSaveId={`jepx-lazer-desk-top-${getUsernameFromMsal(
              activeAccount ? [activeAccount] : accounts
            )}`}
            direction="horizontal"
          >
            <Panel
              id="orderbook-inside"
              order={1}
              defaultSize={50}
              minSize={20}
            >
              <OrderBookGrid />
            </Panel>
            <Box
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              width="14px"
            >
              <PanelResizeHandle
                className="main-resize-handle"
                aria-label="Resize orderbook and config"
                tabIndex={0}
              >
                <Resizer rotate="90deg" />
              </PanelResizeHandle>
            </Box>
            <Panel id="config" order={2} defaultSize={50} minSize={20}>
              <Box
                height={"100%"}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <ConfigTab />
                <FullDepthOrderbook />
              </Box>
            </Panel>
          </PanelGroup>
        </Box>
      </Panel>
      <PanelResizeHandle
        className="main-resize-handle"
        aria-label="Resize orderbook"
        tabIndex={0}
      >
        <Resizer />
      </PanelResizeHandle>
      <Panel id="algos" order={2} defaultSize={60} minSize={20}>
        <Box height={"100%"} minHeight={0}>
          <AlgoFrame />
        </Box>
      </Panel>
    </PanelGroup>
  );
};

export { MainSplit };

type ResizerProps = {
  rotate?: string;
};
const Resizer: FC<ResizerProps> = ({ rotate }) => (
  <svg
    width="22"
    height="10"
    viewBox="0 0 22 12"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ rotate }}
  >
    <circle cx="6" cy="4" r="1.2" fill="#b0b0b0" />
    <circle cx="10" cy="4" r="1.2" fill="#b0b0b0" />
    <circle cx="14" cy="4" r="1.2" fill="#b0b0b0" />

    <circle cx="6" cy="8" r="1.2" fill="#b0b0b0" />
    <circle cx="10" cy="8" r="1.2" fill="#b0b0b0" />
    <circle cx="14" cy="8" r="1.2" fill="#b0b0b0" />
  </svg>
);
